import { V004Algorithm } from '../../../../Algorithm';
import { KeySystemPasswordType, ProtocolVersion, } from '@standardnotes/models';
import { DeriveKeySystemRootKeyUseCase } from './DeriveKeySystemRootKey';
export class CreateUserInputKeySystemRootKey {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(dto) {
        const version = ProtocolVersion.V004;
        const seed = this.crypto.generateRandomKey(V004Algorithm.ArgonSaltSeedLength);
        const keyParams = {
            systemIdentifier: dto.systemIdentifier,
            passwordType: KeySystemPasswordType.UserInputted,
            creationTimestamp: new Date().getTime(),
            seed,
            version,
        };
        const usecase = new DeriveKeySystemRootKeyUseCase(this.crypto);
        return usecase.execute({
            password: dto.userInputtedPassword,
            keyParams,
        });
    }
}
